import axios from '../../axios'

const Login = async (Payload) => {
  const res = await axios.post('admin/adminLogin', Payload);
  return res.data;
}

const LoginWithToken = async () => {
  const res = await axios.post('admin/autoLogin');
  return res.data;
}

const forgetPasswordLink = async (Payload) => {
  const res = await axios.get('admin/sendPasswordResetLink');
  return res?.data;
}

export { Login, forgetPasswordLink, LoginWithToken }
